import {Component, HostBinding, OnInit} from '@angular/core';

@Component({
  selector: 'spb-checkmark-icon',
  templateUrl: './checkmark-icon.component.html',
})
export class CheckmarkIconComponent implements OnInit {
  @HostBinding('class.spb-checkmark-icon') hostBaseClass = true;
  constructor() {
  }

  ngOnInit() {
  }

}
